export var strokeWidth = 4;
export var radius = 20;
export var circumference = 2 * Math.PI * radius;
export var svgSize = radius + strokeWidth / 2;
export var animationDuration = 2;
//# sourceMappingURL=Loader.shared.js.map